import React, { Fragment } from 'react'
import store from '../store'
import { EditOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'hljd'
import { EDIT_CASE_PATH_A } from '@constant'

export default [
  {
    title: '封面图',
    dataIndex: 'cover_path',
    key: 'cover_path',
    render: cover_path => <img src={cover_path + '?imageView2/1/w/100/h/64'} />
  },
  {
    title: '案例名称',
    dataIndex: 'title',
    key: 'title'
  },
  // {
  //   title: (
  //     <Tooltip title="显示在婚礼纪APP中">
  //       短标题<Icon
  //         type="question-circle"
  //         theme="outlined"
  //         style={{ marginLeft: 5 }}
  //       />
  //     </Tooltip>
  //   ),
  //   dataIndex: 'mark_content',
  //   key: 'mark_content',
  //   width: 200,
  //   render: (mark_content, { example_id, shooting_time_long }) => (
  //     <div>
  //       {mark_content}
  //       <a
  //         onClick={store.showMark(mark_content, example_id, shooting_time_long)}
  //       >
  //         <Icon type="edit" />
  //       </a>
  //     </div>
  //   )
  // },
  {
    title: (
      <Tooltip title="可通过调整时间排序">
        案例时间<QuestionCircleOutlined style={{ marginLeft: 5 }} />
      </Tooltip>
    ),
    dataIndex: 'shooting_time_long',
    key: 'shooting_time_long',
    width: 200,
    render: (shooting_time_long, { example_id, mark_content }) => (
      <div>
        {shooting_time_long && shooting_time_long.split(' ')[0]}
        <a
          onClick={store.showTime(mark_content, example_id, shooting_time_long)}
        >
          <EditOutlined />
        </a>
      </div>
    )
  },
  {
    title: '操作',
    dataIndex: 'edit',
    key: 'edit',
    render: (edit, { example_id }) => {
      return (
        <Fragment>
          <p>
            <a
              href={`${EDIT_CASE_PATH_A}/${example_id}?propertyId=${
                store.info && store.info.property ? store.info.property.id : ''
              }`}
            >
              编辑
            </a>
          </p>
          <p>
            <a onClick={store.delCase(example_id)}>移除</a>
          </p>
        </Fragment>
      )
    }
  }
]
